module.exports = __webpack_public_path__ + "static/media/view1.8f91028a.jpg";